import { render, staticRenderFns } from "./TeamPattern.vue?vue&type=template&id=b99bace8&scoped=true&"
import script from "./TeamPattern.vue?vue&type=script&lang=js&"
export * from "./TeamPattern.vue?vue&type=script&lang=js&"
import style0 from "./TeamPattern.vue?vue&type=style&index=0&id=b99bace8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99bace8",
  null
  
)

export default component.exports